import { PropsWithChildren } from 'react';
import styles from './Heading.module.scss';

export function Heading({ children }: PropsWithChildren) {
  return <div className={styles.heading}>{children}</div>;
}
